
import { useState, useEffect, useRef } from 'react';

export const useAudioLevels = (isActive: boolean) => {
  const [levels, setLevels] = useState<number[]>([0.2, 0.4, 0.6, 0.3, 0.5, 0.7, 0.4]);
  const intervalRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    if (isActive) {
      intervalRef.current = setInterval(() => {
        setLevels(prev => prev.map(() => {
          // Simulate varying audio levels with some randomness
          const baseLevel = 0.2;
          const variation = Math.random() * 0.6;
          return Math.min(baseLevel + variation, 0.9);
        }));
      }, 150);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      // Reset to low levels when not active
      setLevels([0.2, 0.4, 0.6, 0.3, 0.5, 0.7, 0.4]);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isActive]);

  return levels;
};
